import { atom } from "jotai";
import { atomWithReset } from "jotai/utils";

export const omrRequestsAtom = atom([]);

export const currentOmrRequestAtom = atom(null);

export const examProcessingStateAtom = atomWithReset(null);

export const allStudentsMatchedAtom = atomWithReset(false);

export const examInDatabaseAtom = atomWithReset(false);

export const classListFileAtom = atom({ classlist: [], class_ids: "" });

export const gradeWithoutMatchingAtom = atom(false);

export const advancedSettingsAtom = atomWithReset({
	differentStarting: false,
	formulaScoring: false,
	compositeScoring: false,
	mrscor: false,
});

export const examRequestErrorStateAtom = atomWithReset({
	lqNum: false,
	hqNum: false,
	qLen: false,
	wholeExamMR: false,
	multipleResponseWeighted: false,
	weightingMultiple: false,
	partial: false,
	overanswering: false,
	penalties: false,
	notes: false,
	classNum: false,
	examTotalMarks: false,
});

export const scannerRequestStateAtom = atomWithReset({
	keys: [],
	term: "",
	reqnum: "",
	courseTitle: "",
	deptID: "",
	program: "1",
	lqNum: "1",
	hqNum: "",
	qLen: "5",
	nKeys: "1",
	a: "3",
	b: "1",
	c: "0",
	d: "2",
	e: "0",
	f: "0",
	k: "7",
	pocketflag: "1",
	initials: "XX",
	l: "0",
	m: "0",
	n: "1",
	o: "0",
	p: "0",
	delivery: "",
	numOpen: "",
	docSize: "",
	instructorName: "",
	department: "",
	email1: "",
	email2: "",
	phone: "",
	address: "",
	singleSided: "",
	mrScor: "",
	assign2: "",
	formulaScoringChecked: false,
	classFromDatabase: "1",
	notes: "",
	wholeExamMR: "",
	notMultipleResponse: "",
	weightingMultiple: "",
	schema: "",
	schemaNotes: "",
	multipleResponseWeighted: "",
	partial: "",
	overanswering: "",
	numQuestions: "",
	numAnswers: "",
	numSingleResponse: "",
	numMultipleResponse: "",
	multipleResponseQuestions: [],
	singleResponseQuestions: [],
	combineIds: [],
	valueNumKeys: "1",
	valueNumQuestions: "",
	valueNumAnswers: "5",
	class_ids: [],
	booklets: "",
	sheets: "",
	tsqs_upload: "",
	sided: "Double sided",
	classRecord: "",
	examDate: "",
	exam_type: "",
	penalties: "",
	compKey1Weight: "",
	compKey2Weight: "",
	compKey3Weight: "",
	compKey4Weight: "",
	compKey5Weight: "",
});

export const OUTPUT_SETTINGS_DEFAULT = {
	scalingEnabled: false,
	scalingTarget: "", // string to allow empty, parsed to number when used
	bonusMarks: "", // flat marks added to each exported student score
	roundingMode: "nearest", // 'nearest' | 'down' | 'up'
	decimalPlaces: 0, // 0-3
	tabulationPointBiserialMode: "crpb", // 'crpb' | 'rpb' | 'legacy_crpb'
	tabulationUseCorrectedPointBiserial: true, // true => CRPB, false => RPB
	reorderedItemAnalysis: false,
	criterionScoreEnabled: false,
	includeQuintileStatistics: false,
	downloadPerClassSection: false,
	oldExamResultFormat: false,
	includeWeightBreakdownColumns: false,
	printAllVersions: true,
	selectedQuestions: null, // null => all questions; [] => none selected
};

export const outputSettingsAtom = atom({ ...OUTPUT_SETTINGS_DEFAULT });

export const selectedClassAtom = atom(null);
export const selectedDeptAtom = atom({ department: "", deptId: "" });

export const combiningClassesArrayAtom = atom([]);

export const termsAtom = atom({
	terms: [],
	termValue: "",
	termNumber: "",
	termsList: [],
});

export const unsavedChangesAtom = atom(false);

export const instanceRowsAtom = atom([]);

export const spotOrderingSelectionModelAtom = atom({
	type: "include",
	ids: new Set(),
});
